import React from 'react';
import {
  Box,
  Typography,
} from '@mui/material';
import {
  DigitalSubmissionNumberRange,
  GroundTruthNumberRange,
} from '../../../redux/types';
import { Colors } from '../../utilities/Colors';

type Props = {
  exerciseGroundTruth: GroundTruthNumberRange;
  submission?: DigitalSubmissionNumberRange;
}

function compareResults(
  correctRange?: [number, number][],
  acceptableRange?: [number, number][],
  answer?: number | 'RTU' | '-' | null,
) {
  // eslint-disable-next-line no-restricted-globals
  if (typeof answer === 'number' && !isNaN(answer)) {
    if (!correctRange || !acceptableRange || answer === undefined || answer === null) {
      return undefined;
    }
    const correct = correctRange.find((rng) => answer >= rng[0] && answer <= rng[1]);
    if (correct) {
      return [Colors.correct, 'Correct Answer'];
    }
    const acceptable = acceptableRange.find((rng) => answer >= rng[0] && answer <= rng[1]);
    if (acceptable) {
      return [Colors.acceptable, 'Acceptable Answer'];
    }
  }
  return [Colors.wrong, 'Wrong Answer'];
}

const RevealedAnsNumberRange: React.FC<Props> = ({
  exerciseGroundTruth,
  submission,
}: Props) => {
  const finalAnswer = compareResults(
    exerciseGroundTruth.payload.correct.range,
    exerciseGroundTruth.payload.acceptable.range,
    submission?.answer,
  );

  return (
    <Box aria-label="exercise-answer">
      <Box display="flex">
        {
          finalAnswer && (
            <Typography style={{ color: finalAnswer[0], fontWeight: 500 }} component="div">{finalAnswer[1]}</Typography>
          )
        }
      </Box>
      <Box display="flex">
        <Typography sx={{ flexBasis: 200 }} color="GrayText" component="div">Correct Answer Range</Typography>
        {
          exerciseGroundTruth.payload.correct.range
            .map((rng, index) => (
              // eslint-disable-next-line react/no-array-index-key
              <Typography sx={{ mr: 2 }} key={index} component="div">
                [
                {rng[0]}
                &nbsp;-&nbsp;
                {rng[1]}
                ]
              </Typography>
            ))
        }
      </Box>
      <Box display="flex">
        <Typography sx={{ flexBasis: 200 }} color="GrayText" component="div">Acceptable Answer Range</Typography>
        {
          exerciseGroundTruth.payload
            .acceptable.range
            .map((rng, index) => (
              // eslint-disable-next-line react/no-array-index-key
              <Typography sx={{ mr: 2 }} key={index} component="div">
                [
                {rng[0]}
                &nbsp;-&nbsp;
                {rng[1]}
                ]
              </Typography>
            ))
        }
      </Box>
    </Box>
  );
};

export default RevealedAnsNumberRange;
